// extracted by mini-css-extract-plugin
export default {"forget-wrapper":"LoginForm_forget-wrapper__xeJMu","enter-wrapper":"LoginForm_enter-wrapper__R7PH4","link":"LoginForm_link__9ADXI"};